import firebase from 'firebase';

const firebaseConfig = {
  apiKey: "AIzaSyDzAPTzHE7EKTYsJj21l00mZXCv9Msx-9k",
  authDomain: "estimatic-v1.firebaseapp.com",
  databaseURL: "https://estimatic-v1.firebaseio.com",
  projectId: "estimatic-v1",
  storageBucket: "estimatic-v1.appspot.com",
  messagingSenderId: "115578563399",
  appId: "1:115578563399:web:82aea2a68993cb8c277a62",
  measurementId: "G-JT8CPE3J0L"
};

const fire = firebase.initializeApp(firebaseConfig);
export default fire;